'use client';

import { useJump } from '@/components/MagicJump';
import { getSpmPositionCode, useGlobalSpmTerminal } from '@/components/Layout/spmTerminal';
import { useRouteCnName } from '@/hooks/useRouteMetadata';
import { useTranslations } from '@/i18n/use-translations';
import { useStore } from '@/providers/app-store-provider';
import { useSpmDomAttr, withSpmCnt } from '@/reporting/spm';
import { EPlatform } from '@/utils/enums/platform-enum';
import { sensorsTrack } from '@/utils/sensors';

interface SubscribeCoupon2026Props {
  bottomSubscribeBoxTxt?: string;
}

export default function SubscribeCoupon2026({
  bottomSubscribeBoxTxt = '',
}: SubscribeCoupon2026Props) {
  const token = useStore((state) => state.token);
  const userEmail = useStore((state) => state.userInfo?.email);
  const setLoginRegisterShow = useStore((state) => state.setShowLoginRegisterDialog);
  const t = useTranslations('layout.footer');
  const toJumpTarget = useJump();
  const pageName = useRouteCnName();
  const spmPage = useGlobalSpmTerminal(EPlatform.WEB);
  const submitSubscriptionSpmCnt = getSpmPositionCode(
    spmPage,
    'footer_subscribe',
    'submit_subscription',
  );
  const submitSubscriptionDomSpm = useSpmDomAttr(submitSubscriptionSpmCnt);
  const singleLineTitle = bottomSubscribeBoxTxt.replace(/<br\s*\/?>/gi, ' ');

  const handleSubscribe = () => {
    // 与 US 订阅入口使用同一事件及坑位，登录/未登录分支共用点击编码。
    const properties = { page_name: pageName, btn_name: t('subscribe.subscribeButton') };
    sensorsTrack(
      'EDMModule_Click',
      submitSubscriptionSpmCnt ? withSpmCnt(properties, submitSubscriptionSpmCnt) : properties,
    );
    if (token) {
      toJumpTarget({
        Jump_target: `/account/my-account?email=${userEmail}`,
        jump_type: 4,
      });
      return;
    }

    setLoginRegisterShow({
      show: true,
      eventType: 'bottom_register',
      situation: '底部导航领券',
    });
  };

  return (
    <section className="flex w-full items-center justify-center bg-black px-[72px] py-[40px] text-primary-white">
      <div className="flex w-max max-w-full shrink-0 flex-col items-start gap-[12px]">
        <h2
          className="whitespace-nowrap font-bb text-[20px] leading-[24px]"
          dangerouslySetInnerHTML={{ __html: singleLineTitle }}
        />
        <button
          type="button"
          className="flex h-[50px] w-full cursor-pointer items-center gap-[8px] rounded-[6px] border border-[#d1d9e0] bg-primary-white p-[6px] pl-[12px] text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-purple"
          onClick={handleSubscribe}
          {...submitSubscriptionDomSpm}
        >
          <span className="min-w-0 flex-1 truncate font-br text-[14px] leading-[17px] text-[#6c6c6c]">
            {t('subscribe.emailPlaceholder')}
          </span>
          <span className="flex h-[38px] w-[96px] shrink-0 items-center justify-center rounded-[4px] bg-primary-purple px-[8px] text-center font-br text-[12px] leading-[14px] text-primary-white">
            {t('subscribe.subscribeButton')}
          </span>
        </button>
      </div>
    </section>
  );
}
